import React from 'react'
import { Outlet } from 'react-router-dom'

const SpineAvatars = () => {
  return <Outlet />
}

export default SpineAvatars
